import React, { useState, useEffect } from "react";
import i18n from '../../i18n';

type ListItemProps = {
  image: string,
  title: string,
  text: string,
  dataTestId?: string
}

export const ListItem: React.FC<ListItemProps> = (props) => {
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    let title = i18n.t(props.title);
    let text = i18n.t(props.text);
    if(title.length > 0 || text.length > 0) {
      setShouldShow(true);
    }
  }, [shouldShow, props.title, props.text]);
  

  return (
    <>
      {shouldShow &&
        <div data-testid={props.dataTestId} className="col-12 item">
          <div className="row">
            <div className="item-icon">
              <img src={props.image} className="" alt="icon" />
            </div>
            <div className="item-text">
              <h3>{i18n.t(props.title)}</h3>
              <p dangerouslySetInnerHTML={{__html: i18n.t(props.text)}}></p>
            </div>
          </div>
        </div>}
    </>
  );
}